import {connect} from 'react-redux';
import {ArchiveButton} from '../../components/ArchiveButton/ArchiveButton';
import {IApplicationState} from '../../../../../../../types/types';
import {IArchiveButtonEvents, IArchiveButtonFields} from '../../components/ArchiveButton/types';
import {IArchiveButtonHOCProps} from './types';
import {onClick} from './events/onClick';
import { getSectionType } from '../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { getBoard } from '../../../../../../../store/model/selectors/getBoardById';
import { TStatus } from '../../../../../../../types/model';
import { getAuthUserSupport } from '../../../../../../../store/model/authUser/selectors/getAuthUserSupport';
import { getShowProFeaturesTrial } from '../../../../../../../store/model/authUser/selectors/getShowProFeaturesTrial';
import { getIsUserEssentialPlanOnly } from '../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import { getAsidePanelActionsButtonTooltip } from '../../../../asidePanel/helpers/getAsidePanelActionsButtonTooltip';
import { ARCHIVE_TITLE } from '../../../../cardDetails/ArchiveButton/components/ArchiveButton/constants';

const mapStateToProps = (
    state: IApplicationState,
    props: IArchiveButtonHOCProps,
): IArchiveButtonFields => {
    let { boardId } = props;
    const sectionType = getSectionType(state, boardId, null, null, 'allowArchive');
    const isDisallow = sectionType === ESettingsSectionType.DISALLOW;
    const { status } = getBoard(state, boardId);
    const isShow = (
        getAuthUserSupport(state,'supportBoardArchive') &&
        status === TStatus.STATUS_ACTIVE &&
        (sectionType === ESettingsSectionType.DEFAULT || isDisallow)
    );
    return {
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
        isDisallow,
        isProFeature: getShowProFeaturesTrial(state),
        isShow,
        tooltip: ARCHIVE_TITLE,
    }
};
const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IArchiveButtonHOCProps
): IArchiveButtonEvents => ({
    onClick: () => dispatch(onClick(boardId)),
});

export const ArchiveButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(ArchiveButton);

ArchiveButtonHOC.displayName = 'ArchiveButtonHOC';
